/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services/hub.service';

interface Res {
  data: {
    data: any;
    [key: string]: any;
  };
}

interface Params {
  [key: string]: any;
}

export const discussionsActions = {
  getDiscussions,
  getComments,
  deleteDiscussion,
  deleteComment,
  getCategories,
  addCategory,
  deleteCategory,
};

function unwrap(promise: any, context: string): any {
  if (promise && 'data' in promise) return promise.data;
  console.log(`error in actions ${context}`);
  return Promise.reject(`Error: ${context}`);
}

function getDiscussions(): Promise<any> {
  return services
    .get<Res>(`/discussions/list?limit=500`)
    .then((p) => unwrap(p, 'get discussions'));
}

function getComments(id: string | number): Promise<any> {
  return services
    .get<Res>(`/discussions/${id}/comments`)
    .then((p) => unwrap(p, 'get comments'));
}

function deleteDiscussion(id: string | number): Promise<any> {
  return services
    .delete<Res>(`/discussions/delete/${id}`)
    .then((p) => unwrap(p, 'delete discussion'));
}

function deleteComment(id: string | number): Promise<any> {
  return services
    .delete<Res>(`/discussions/comments/delete/${id}`)
    .then((p) => unwrap(p, 'delete comment'));
}

function getCategories(): Promise<any> {
  return services
    .get<Res>(`/discussions/categories/list`)
    .then((p) => unwrap(p, 'get categories'));
}

function addCategory(params: Params): Promise<any> {
  return services
    .post<Res>(`/discussions/categories/add`, params)
    .then((p) => unwrap(p, 'add category'));
}

function deleteCategory(id: string | number): Promise<any> {
  return services
    .delete<Res>(`/discussions/categories/delete/${id}`)
    .then((p) => unwrap(p, 'delete category'));
}
